import React from "react";
import { connect } from "react-redux";

import LegacyCheckout from "..";
import EditRecap from "./EditRecap";
import Recap from "./Recap";

/**
 * /checkout :
 *  - une commande ouverte depuis « Mes commandes » (auth.editContext, voir
 *    Orders/editOrder) → le récapitulatif en mode édition du design ;
 *  - un reste d'édition de l'ancien parcours sans ce contexte (état
 *    persistant d'avant la mise à jour) → l'ancienne page, qui sait le
 *    terminer ;
 *  - sinon, le nouveau récapitulatif d'une nouvelle commande.
 */
const CheckoutEntry = ({ editContext, legacyEditing, ...props }) => {
  if (editContext) return <EditRecap {...props} />;
  if (legacyEditing) return <LegacyCheckout {...props} />;
  return <Recap {...props} />;
};

const mapStateToProps = (state) => ({
  editContext: state?.auth?.editContext,
  legacyEditing: state?.auth?.editOrder === true || state?.auth?.edit === true,
});

export default connect(mapStateToProps)(CheckoutEntry);
